export const LOAN_TYPE_NAMES = {
  NEW: 'Empréstimo Novo',
  FGTS_NEW: 'FGTS',
  PAB: 'PAB',
  CLIX: 'Clix',
  CLIX_CLEAN: 'Clix Clean',
  CLIX_BENEFITS_CARD: 'Clix Cartão Benefício',
  CLIX_CREDIT_CARD: 'Clix Cartão de crédito',
  PORTABILITY: 'Portabilidade',
  PORTABILITYWITHOUTREFIN: 'Portabilidade sem refin',
  PORT_REFIN: 'Portabilidade com refin',
  PORT_WITH_MARGIN: 'Portabilidade',
  PORT_WITHOUT_MARGIN: 'Portabilidade',
  REFIN: 'Refinanciamento',
  FUTUREMARGIN: 'Margem Futura',
  GENERAL_STATUS: 'Status Gerais',
  NEW_CREDIT_LINES: 'Novas linhas de crédito',
  SHOPPING: 'Loja Meutudo',
  INCOME: 'Seguro Renda',
  LOAN_PROTECTION: 'Seguro Prestamista',
  PIX_CREDIT_CARD: 'Pix cartão de crédito',
  CONSIGNED_CARD_RMC: 'Cartão consignado - Adesão',
  CONSIGNED_CARD_RMC_PIX: 'Cartão Consignado - PIX',
  BENEFIT_CARD_RCC: 'Cartão benefício - Adesão',
  BENEFIT_CARD_RCC_PIX: 'Cartão Benefício - PIX',
  LIFE_INSURANCE: 'Seguro de Vida',
  CONSIGNED_PIX: 'Pix Consignado - INSS',
  BENEFIT_CARD_RCC_INVOICE_INSTALLMENT: 'Cartão Benefício - Fatura parcelada',
  BENEFIT_CARD_RCC_INVOICE_INSTALLMENT_PIX: 'Cartão Benefício - Fatura parcelada',
  CONSIGNED_CARD_RMC_INVOICE_INSTALLMENT: 'Cartão Consignado - Fatura parcelada',
  CONSIGNED_CARD_RMC_INVOICE_INSTALLMENT_PIX: 'Cartão Consignado - Fatura parcelada',
  CONSIGPRIV: 'Consignado Privado',
  PORT_CT: 'Consignado Privado',
  ASSURANCE: 'Seguro desativado',
  INTEGRATION: 'Integração',
  CONSIGPRIV_REFIN: 'Consignado Privado Refinanciamento',
  CONSIGPRIV_PORT: 'Consignado Privado Portabilidade',
  INSURANCE: 'Seguro Renda Protegida',
  PIX_CONSIGNADO: 'Pix Consignado',
  PROTECTED_LIFE_INSURANCE: 'Seguro Vida Protegida',
  CARD_INSURANCE: 'Seguro de Cartão',
};

export const LOAN_TYPES = {
  NEW: 'NEW',
  PORTABILITY: 'PORTABILITY',
  PORTABILITYWITHOUTREFIN: 'PORTABILITYWITHOUTREFIN',
  REFIN: 'REFIN',
  FUTUREMARGIN: 'FUTUREMARGIN',
  FGTS_NEW: 'FGTS_NEW',
  CLIX: 'CLIX',
  PAB: 'PAB',
  PIX_CREDIT_CARD: 'PIX_CREDIT_CARD',
  CONSIGNED_CARD_RMC: 'CONSIGNED_CARD_RMC',
  CONSIGNED_CARD_RMC_PIX: 'CONSIGNED_CARD_RMC_PIX',
  BENEFIT_CARD_RCC: 'BENEFIT_CARD_RCC',
  BENEFIT_CARD_RCC_PIX: 'BENEFIT_CARD_RCC_PIX',
  PORT_REFIN: 'PORT_REFIN',
  LIFE_INSURANCE: 'LIFE_INSURANCE',
  CONSIGNED_PIX: 'CONSIGNED_PIX',
  PORT_WITH_MARGIN: 'PORT_WITH_MARGIN',
  PORT_WITHOUT_MARGIN: 'PORT_WITHOUT_MARGIN',
  BENEFIT_CARD_RCC_INVOICE_INSTALLMENT: 'BENEFIT_CARD_RCC_INVOICE_INSTALLMENT',
  BENEFIT_CARD_RCC_INVOICE_INSTALLMENT_PIX: 'BENEFIT_CARD_RCC_INVOICE_INSTALLMENT_PIX',
  CONSIGNED_CARD_RMC_INVOICE_INSTALLMENT: 'CONSIGNED_CARD_RMC_INVOICE_INSTALLMENT',
  CONSIGNED_CARD_RMC_INVOICE_INSTALLMENT_PIX: 'CONSIGNED_CARD_RMC_INVOICE_INSTALLMENT_PIX',
  INCOME: 'INCOME',
  LOAN_PROTECTION: 'LOAN_PROTECTION',
  INTEGRATION: 'INTEGRATION',
  PORT_CT: 'PORT_CT',
  CARD_INSURANCE: 'CARD_INSURANCE',
};

function LoanType(props: any, isConsigPrivPort?: boolean) {
  if (props) {
    if (isConsigPrivPort) {
      return LOAN_TYPE_NAMES.CONSIGPRIV_PORT;
    }

    return LOAN_TYPE_NAMES[props.value] || LOAN_TYPE_NAMES[props] || null;
  }
  return null;
}

LoanType.LOAN_TYPES = LOAN_TYPES;

export type Loans = keyof typeof LOAN_TYPES;

export default LoanType;
